import React from "react";
import { ReactComponent as TrainingLibraryIcon } from "../svgs/training-library.svg";
import { ReactComponent as AlertsIcon } from "../svgs/alerts.svg";
import { ReactComponent as InventoryIcon } from "../svgs/inventory.svg";
import { ReactComponent as ProcessingIcon } from "../svgs/processing.svg";

export const BottomNav = ({
  activeTab = "processing",
  onProcessingClick,
  onInventoryClick,
  onAlertsClick,
}) => {
  const navItems = [
    {
      id: "training",
      label: "Training Library",
      icon: <TrainingLibraryIcon style={{ width: "36px", height: "36px" }} />,
      onClick: () => {
        // Open training library in a new tab
        window.open(
          "https://intercom.help/legobricktakeback/en/collections/13223162-staff-help-articles",
          "_blank"
        );
      },
    },
    {
      id: "alerts",
      label: "Alerts",
      icon: <AlertsIcon style={{ width: "36px", height: "36px" }} />,
      onClick: () => {
        if (onAlertsClick) {
          onAlertsClick();
        } else {
          console.log("Navigate to Alerts");
        }
      },
    },
    {
      id: "inventory",
      label: "Inventory",
      icon: <InventoryIcon style={{ width: "36px", height: "36px" }} />,
      onClick: () => {
        if (onInventoryClick) {
          onInventoryClick();
        } else {
          console.log("Navigate to Inventory");
        }
      },
    },
    {
      id: "processing",
      label: "Processing",
      icon: (
        <ProcessingIcon
          style={{ width: "36px", height: "36px", marginLeft: "8px" }}
        />
      ),
      onClick: () => {
        if (onProcessingClick) {
          onProcessingClick();
        } else {
          console.log("Navigate to Processing");
        }
      },
    },
  ];

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-[#060E23] border-t border-[#282F44] z-30 px-6">
      <div className="flex justify-around items-center py-3">
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={item.onClick}
            className={`flex flex-col items-center justify-center px-4 py-2 group ${
              activeTab === item.id
                ? "text-[#2256DB]"
                : "text-[#C6CCE8] hover:text-[#2256DB]"
            }`}
          >
            <div
              className={`mb-2 ${
                activeTab === item.id
                  ? "[&>svg]:fill-[#2256DB] [&>svg>path]:fill-[#2256DB]"
                  : "[&>svg]:fill-[#A1A7C2] [&>svg>path]:fill-[#A1A7C2] group-hover:[&>svg]:fill-[#2256DB] group-hover:[&>svg>path]:fill-[#2256DB]"
              }`}
            >
              {item.icon}
            </div>
            <span className="text-[16px] font-medium leading-[21px]">
              {item.label}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
};
